"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var TabPanel_1 = require("../../atoms/TabPanel");
var Tabs_1 = require("../../molecules/Tabs");
var styles_1 = require("./styles");
exports.TabView = react_1.default.memo(function (_a) {
    var _b = _a.defaultValue, defaultValue = _b === void 0 ? 0 : _b, label = _a.label, tabs = _a.tabs, panels = _a.panels, buttons = _a.buttons, offsetHeight = _a.offsetHeight, enableMinWidth = _a.enableMinWidth;
    var _c = react_1.default.useState(defaultValue), value = _c[0], setValue = _c[1];
    var classes = (0, styles_1.useStyles)({ offsetHeight: offsetHeight, enableMinWidth: enableMinWidth });
    var handleChange = (0, react_1.useCallback)(function (event, newValue) {
        setValue(newValue);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(core_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(Tabs_1.Tabs, { value: value, tabs: tabs, onChange: handleChange, label: label }) })), buttons && ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: 3, style: { display: 'flex', flexDirection: 'row-reverse', gap: 5 } }, { children: buttons })))] })), (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ mt: 2, className: classes.list }, { children: panels.map(function (_a, panelIndex) {
                    var id = _a.id, children = _a.children, keepMounted = _a.keepMounted;
                    return ((0, jsx_runtime_1.jsx)(TabPanel_1.TabPanel, __assign({ id: id, hidden: value !== panelIndex, keepMounted: keepMounted }, { children: children }), id));
                }) }))] }));
});
exports.TabView.displayName = 'TabView';
